const info={
    ZH: {  //中文翻译
    zhanghu:"账户充值",
    edu:"充值额度",
    shuru:"请输入充值金额",
    fangshi:"支付方式",
    choose:"请选择",
    ZFB:"支付宝",
    WX:"微信",
    shouxu:"手续费",
    shifu:"实付金额",
    saoma:"请扫码支付",
    chongz:"充值",
    my:"我的钱包",
    names:"我的收件人",
    xinxi:"收件人信息",
    mingzi:"收件人名",
    compan:"公司名",
    zhou:"州省",
    city:"城市",
    youbian:"邮编",
    dizhi:"地址",
    dizhi1:"地址1",
    dizhi2:"地址2",
    dizhi3:"地址3",
    dian:"电话",
    shou:"手机",
    you:"邮箱",
    huzhao:"护照号",
    shui:"税号",
    caozuo:"操作",
    shan:"删除",
    xiu:"修改",
    add:"添加联系人",
    xinzen:"新增联系人",
    bi:"必填",
    xuan:"选填",
    guojia:"收件地址",
    xiangq:"交易详情",
    guo:"国家",
    xiug:"确认修改",
    

    },  
    EN: {  //英文翻译
        zhanghu:"Account recharge",
    edu:"Recharge limit",
    shuru:"Please enter the recharge amount",
    fangshi:"Payment method",
    choose:"Please select",
    ZFB:"ZFB",
    WX:"WX",
    shouxu:"commission",
    shifu:"Pay Amount",
    saoma:"Please scan the code to pay",
    chongz:"Recharge",
    my:"My wallet",
    names:"My recipients",
    xinxi:"Recipient information",
    mingzi:"Recipient name",
    compan:"Company name",
    zhou:"State and province",
    city:"city",
    youbian:"Zip code",
    dizhi:"address",
    dizhi1:"address1",
    dizhi2:"address2",
    dizhi3:"address3",
    dian:"Telephone",
    shou:"mobile phone",
    you:"mailbox",
    huzhao:"passport No",
    shui:"duty paragraph",
    caozuo:"operation",
    shan:"delete",
    xiu:"modify",
    add:"Add a Contact",
    xinzen:"New contact",
    bi:"Required",
    guojia:"Receiving address",
    xiangq:"transaction details",
    xuan:"Optional filling",
    guo:"country",
    xiug:"Confirm modification",

    }
}
export default info